import React, { useEffect, useRef } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import CustomizeHeader from '../components/header/customizeHeader'
import { MainHeaderLeft } from '../components/header'
import homeTrack from './homeTrack'
import PermissionsPage from '../components/permissionsPage'
import Aside from '../components/aside'
import workbenchForceGuide, { GUIDE_KEYS } from './workbench/forceGuideConfig'
import './index.less'

export default () => {
  useEffect(() => {
    document.title = '美念'
  }, [])

  const pageAuth = () => {
    if (location.pathname.startsWith('/meinian/home/intellectRecommend') && !teamHasAuth('meinian_blog_recommend')) {
      return true
    }
    if (location.pathname.startsWith('/meinian/home/sample') && !teamHasAuth('meinian_sample_manager')) {
      return true
    }
    if ((location.pathname.startsWith('/meinian/home/analysis/choose') || location.pathname.startsWith('/meinian/home/analysis')) && !teamHasAuth('meinian_blog_analysis')) {
      return true
    }
    return false
  }
  const homeAside = useRef()
  workbenchForceGuide.useEmit(GUIDE_KEYS.STEP_1, homeAside)

  return <div className="meinian-home">
    <Aside domRef={homeAside} />
    {
      pageAuth() ? <PermissionsPage type={{
        '/meinian/home/intellectRecommend': 'intellectRecommend',
        '/meinian/home/sample': 'sample',
        '/meinian/home/analysis/choose': 'analysis'
      }[location.pathname]}
      /> : <RealPage />
    }
  </div>
}

const RealPage = () => {
  const location = useLocation()

  useEffect(() => {
    homeTrack()
  }, [location.pathname])

  const customizeHeader = [
    '/home/workbench',
    '/home/sample',
    '/home/coll/detail',
    '/home/analysis',
    '/home/workbench/marking',
    '/home/category-tags',
    '/home/intellectRecommend'
  ]

  const hiddenCustom = customizeHeader.some(item => location.pathname.startsWith(item))

  return <div className="home-content" style={{ width: 'calc(100vw - 80px' }}>
    {
    !hiddenCustom && <CustomizeHeader
      renderLeft={() => <MainHeaderLeft />}
    />
  }
    <Outlet />
  </div>
}
